var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M14.3067 12.86L10.64 9.19333C10.6067 9.16 10.5733 9.14667 10.54 9.12667C10.5133 9.09333 10.5 9.05333 10.4733 9.02C10.2133 8.76 9.79333 8.76 9.53333 9.02C8.89333 9.65333 8.06 10 7.16667 10C5.32667 10 3.83333 8.50667 3.83333 6.66667C3.83333 4.82667 5.32667 3.33333 7.16667 3.33333C9.00667 3.33333 10.5 4.82667 10.5 6.66667C10.5 7.03333 10.8 7.33333 11.1667 7.33333C11.5333 7.33333 11.8333 7.03333 11.8333 6.66667C11.8333 4.09333 9.74 2 7.16667 2C4.59333 2 2.5 4.09333 2.5 6.66667C2.5 9.24 4.59333 11.3333 7.16667 11.3333C8.18667 11.3333 9.15333 11 9.96 10.4L13.3667 13.8067C13.4933 13.9333 13.66 14 13.8333 14C14.0067 14 14.1733 13.9333 14.3067 13.8067C14.5667 13.5467 14.5667 13.12 14.3067 12.86Z",
    fill: "#FF5722"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.a7d3f2de20627927e27e0bca5067513d.svg";
export { ForwardRef as ReactComponent };